<script setup>
const props = defineProps({
  images: {
    type: Array,
    default: () => []
  }
})
</script>

<template>
  <div class="container rounded-xl">
    <div class="flex space-x-4 overflow-x-scroll mb-4">
      <img
        v-for="image in props.images"
        :key="image.id"
        alt="business name"
        class="shadow-lg rounded-xl max-w-sm"
        :src="image.url"
      >
    </div>
  </div>
</template>

<style scoped>

</style>
